import { BeneficiaryFilterEnumType, NULL_AS_STRING } from '@repo/shared/dtos/beneficiary'
import { EnumSchemaItem } from '@repo/shared/dtos/structured-data'
import { useT } from '@repo/ui/hooks'

import EnumFilterForm from './EnumFilterForm'
import { FilterWrapper } from './FilterWrapper'
import { FilterProps } from './types'

export default function EnumFilter(props: FilterProps<BeneficiaryFilterEnumType, EnumSchemaItem>) {
  const { t, tc } = useT({ keyPrefix: 'beneficiary.filters' })
  const numberOfValues = props.filter.value.length
  const enumValues = props.schemaItem.enumValues

  const optionalsCrushed = {
    value: [...props.filter.value]
      .map((v) => (!v ? tc(NULL_AS_STRING) : v))
      // re-order values by their index in the enum values
      .sort((a, b) => enumValues.indexOf(a) - enumValues.indexOf(b))
      .join(` ${tc('or')} `),
    operator: numberOfValues === 1 ? t('operators.is') : undefined,
  }

  if (props.readonly) return <FilterWrapper {...props} optionalsCrushed={optionalsCrushed} />

  return (
    <FilterWrapper
      {...props}
      optionalsCrushed={optionalsCrushed}
      renderForm={(onCancel) => (
        <EnumFilterForm
          schemaItem={props.schemaItem}
          filter={props.filter}
          onChange={props.onChange}
          onCancel={onCancel}
        />
      )}
    />
  )
}
